export const ROUTER_LINK_TYPE = '$$router_link';
export const ROUTER_DISMISS_ALL_TYPE = '$$router_dismissAll';
export const ROUTER_DISMISS_TYPE = '$$router_dismiss';
export const ROUTER_BACK_TYPE = '$$router_goBack';
export const ROUTER_SET_PARAMS_TYPE = '$$router_setParams';
